module.exports = __webpack_public_path__ + "fonts/phetsarath_ot.0dff2433.woff";